import { Controller } from "@hotwired/stimulus";

/*
 * Redirects to a page after click
 *
 * <div data-controller="redirect" data-redirect-url-value="URL">
 *   <a download href="#" data-action="redirect#to"></a>
 * </div>
 */
export default class extends Controller {
  static values = {
    url: String,
  };

  to(event) {
    if (!this.urlValue) {
      console.error(
        "Missing data-redirect-url-value attribute on",
        this.element,
      );
      return;
    }

    setTimeout(() => (window.location = this.urlValue), 3000);
  }
}
